












































































import { Vue, Component, Prop } from 'vue-property-decorator';
import * as api from '@/api';
/**
 * 自定义字段展示列表
 *
 * @author liyuyao
 * @date 03/12/2020
 */
@Component({
    components: {}
})
export default class AssignedExtraSetting extends Vue {
    @Prop({
        default: () => {
            return {
                name: '单行文本',
                type: '1',
                inputType: 'SINGLE_LINE_TEXT',
                defaultValue: '',
                isRequired: false,
                isHidden: false,
                validator: ''
            };
        }
    })
    data: CommonTypes.customField;

    settingType: string = 'special';
    appointAssigned: boolean = true;
    ctiInfo: any = {};
    rgItemId: number = null;
    searchList: any = [];
    searchType: string = 'allCti';

    isItemHidden: boolean = false;
    isAssignedHidden: boolean = false;

    ctiSpecialList: CommonTypes.mapObject[] = [];
    itemsScope: CommonTypes.mapObject = [];
    treeParams: any = {};
    categoryList: any[] = [];

    mounted() {
        const extraSettings = this.data.extraSettings;
        if (extraSettings) {
            this.appointAssigned = extraSettings.specificAssigned;
            this.isAssignedHidden = extraSettings.isAssignedHidden || false;
            this.isItemHidden = extraSettings.isItemHidden || false;
            const itemsScope = extraSettings.itemsScope;
            if (!itemsScope) {
                this.settingType = 'all';
            } else if (itemsScope.ctiSpecialList) {
                // ctiSpecialList字段返回带有父级节点的已选目录，用于回显
                this.ctiSpecialList = this.formatCtiSpecialList(itemsScope.ctiSpecialList);
                this.itemsScope = itemsScope;
                this.formatLayerRequestParams();
                this.settingType = 'special';
            } else if (itemsScope.itemId) {
                if (extraSettings.isItemHidden) {
                    this.ctiInfo = itemsScope;
                    this.searchCTIbyName(itemsScope.itemName);
                } else {
                    console.log('itemsScope', itemsScope);
                    this.settingType = 'special';
                    this.ctiSpecialList = [itemsScope];
                }
            } else if (itemsScope.rgId) {
                this.settingType = 'rg';
            }
        }
    }
    onVisibleChanged(visible: boolean) {
        // 点击输入框后再请求数据
        if (visible && !this.categoryList.length) {
            this.getOptionData({
                categoryIds: this.treeParams.categoryIds,
                typeIds: this.treeParams.typeIds,
                itemIds: this.treeParams.itemIds
            });
        }
    }
    onCategoryChanged() {
        this.formatFormRequestParams();
        this.formatLayerRequestParams();
        this.settingChange();
    }
    formatFormRequestParams() {
        // 根据ctiSpecialList字段结构处理form接口的传参
        this.itemsScope = {
            categoryIds: [],
            typeIds: [],
            itemIds: []
        };
        const catalogs = ['categoryIds', 'typeIds', 'itemIds'];
        this.ctiSpecialList.forEach(option => {
            const level = option.length - 1;
            this.itemsScope[catalogs[level]].push(Number(option[level].split('/')[0]));
        });
    }
    formatLayerRequestParams() {
        // 根据ctiSpecialList字段结构处理layer接口的传参
        this.treeParams = {
            categoryIds: [],
            typeIds: [],
            itemIds: []
        };
        const catalogs = ['categoryIds', 'typeIds', 'itemIds'];
        this.ctiSpecialList.forEach(option => {
            // 选中二级或三级目录的情况，要将其父节点ID都传至layer接口，否则影响二级、三级兄弟节点的回显
            option.forEach((item, index) => {
                this.treeParams[catalogs[index]].push(Number(item.split('/')[0]));
            });
        });
    }
    formatCtiSpecialList(items) {
        // 通过字段个数判断已选项的层级
        return items.map(item => {
            const result = [];
            result.push(`${item.categoryId || 0}/${item.categoryName}`);
            if (item.typeId) {
                result.push(`${item.typeId || 0}/${item.typeName}`);
                if (item.itemId) {
                    result.push(`${item.itemId || 0}/${item.itemName}`);
                }
            }
            return result;
        });
    }
    formatLabel(labels, selectedOptions, value) {
        return value.map(item => item.split('/')[1]).join('/');
    }
    formatParams() {
        let obj = {
            specificAssigned: this.appointAssigned,
            isItemHidden: this.isItemHidden,
            isAssignedHidden: this.isAssignedHidden
        };
        let itemsScope = {};
        if (this.isItemHidden) {
            itemsScope = this.ctiInfo || {};
        } else {
            if (this.settingType === 'rg') {
                itemsScope = {
                    rgId: this.rgId
                };
            } else if (this.settingType === 'special') {
                itemsScope = this.itemsScope;
            }
        }
        obj = Object.assign(obj, {
            itemsScope: itemsScope
        });
        console.log('obj', obj);
        return obj;
    }

    // 处理接口返回的树形数据 categoryId, categoryName ,typeId, typeName, itemId, itemName
    handleTreeData(currentArray, slugArr, level) {
        const result = [];
        currentArray.forEach(item => {
            const obj: any = {};
            obj.value = `${item[slugArr[level] + 'Id']}/${item[slugArr[level] + 'Name']}`;
            obj.label = item[slugArr[level] + 'Name'];
            obj.isLeaf = level === 2;
            obj.level = level + 1;
            obj.parent = item.parentId || 0;
            // 对最末层的rgId单独处理
            if (item.rgId && item.rgName) {
                obj.label += '（' + item.rgName + '）';
                obj.data = {
                    itemId: item[slugArr[level] + 'Id'],
                    rgId: item.rgId
                };
            }
            if (item.children) {
                // “找不到合适的目录”隐藏二三级目录
                if (!(obj.label === '找不到合适的目录' && slugArr[level] === 'category')) {
                    obj.children = this.handleTreeData(item.children, slugArr, level + 1);
                    obj.isLeaf = true;
                }
            }
            result.push(obj);
        });
        return result;
    }
    settingChange(type?: string) {
        if (type === 'scope' && !this.categoryList.length) {
            // 首次选中“指定目录”时，查询所有的一级目录
            this.getCidList();
        }
        this.$emit('change', this.formatParams());
    }

    async getOptionData(requestParam: any) {
        const tree = await this.getTreeData(requestParam);
        this.categoryList = this.handleTreeData(tree, ['category', 'type', 'item'], 0);
    }
    async loadData(item, callback) {
        let requestParam = {};
        if (!item || item.level === 0) {
            requestParam = {};
        } else if (item.level === 1) {
            requestParam = {
                categoryIds: [Number(item.value.split('/')[0])]
            };
        } else if (item.level === 2) {
            requestParam = {
                typeIds: [Number(item.value.split('/')[0])]
            };
        }
        const data = await this.getNextLevelData(item, requestParam);
        callback(data);
    }
    async getNextLevelData(item: any, requestParam: any) {
        // 根据当前点击节点的value请求二级、三级数据
        const data = await this.getTreeData(requestParam);
        switch (item.level) {
            case 0:
                return this.handleTreeData(data, ['category', 'type', 'item'], item.level);
            case 1: {
                const node = data.find(e => e.categoryId === Number(item.value.split('/')[0]));
                const categoryChildren = this.handleTreeData(node?.children || [], ['category', 'type', 'item'], item.level);
                return categoryChildren;
            }
            case 2: {
                const category = data.find(e => e.categoryId === item.parent);
                if (category && category.children) {
                    const type = category.children.find(e => e.typeId === Number(item.value.split('/')[0]));
                    const typeChildren = this.handleTreeData(type?.children || [], ['category', 'type', 'item'], item.level);
                    return typeChildren;
                } else {
                    return [];
                }
            }
            default:
                return [];
        }
    }
    async searchCti(query: string) {
        if (!query) {
            // 清空query后，根据当前的value请求数据进行回显
            this.getOptionData({
                categoryIds: this.treeParams.categoryIds,
                typeIds: this.treeParams.typeIds,
                itemIds: this.treeParams.itemIds
            });
            return;
        }
        const res = await api.ctiApi.searchCti({
            keyword: query,
            sceneId: 1
        });
        const { code, data } = res;
        if (code === 200) {
            this.categoryList = this.handleTreeData(data.items, ['category', 'type', 'item'], 0);
        }
    }
    async getTreeData(requestParam: any) {
        const res = await api.spaceApi.getAuthSpaceCti(
            'ticket',
            {
                ...requestParam,
                createScene: false,
                filterByAuth: false,
                queryAllChild: true
            },
            true
        );
        const { data } = res;
        return data.items || [];
    }
    async getCidList() {
        const tree = await this.getTreeData({});
        this.categoryList = this.handleTreeData(tree, ['category', 'type', 'item'], 0);
    }

    async searchCTIbyName(query: string) {
        const res = await api.ctiApi.searchCTIbyName(query);
        this.searchList = res.data.items;
    }
    changeCtiHidden() {
        this.ctiSpecialList = [];
        this.settingChange();
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
